
import { defineComponent } from 'vue';
import VTable from '@/components/vendor/basic/table/VTable.vue';
import VTableHeader from '@/components/vendor/basic/table/VTableHeader.vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import TheProfessionalDocumentUpload
  from '@/views/professional/documents/parts/TheProfessionalDocumentUpload.vue';
import VTableBody from '@/components/vendor/basic/table/VTableBody.vue';
import VLoader from '@/components/vendor/VLoader.vue';
import useCapabilities from '@/resources/capabilities';
import TheProfessionalDocumentShowModal
  from '@/views/professional/documents/parts/TheProfessionalDocumentShowModal.vue';
import Media from '@/api/objects/Media';

export default defineComponent({
  // TODO: This could be refactored to be used for any role
  name: 'TheProfessionalDocumentList',
  components: {
    TheProfessionalDocumentShowModal,
    VLoader,
    VTableBody,
    TheProfessionalDocumentUpload,
    VButton,
    VTableHeader,
    VTable,
  },
  props: {
    media: {
      type: Array,
      required: false,
    },
    status: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  data() {
    return {
      showAddMedia: false,
      modalToShow: null,
      currentMedia: null as null | Media,
    };
  },
  methods: {
    mediaConfirm() {
      this.showAddMedia = false;
      this.$emit('refresh-media');
    },
  },
});
